import styled from 'styled-components';
import { Image, ImageBck } from '~/components/Atoms';
import { getThemeByPath } from '~/utils';

const defaultPersonImageHeight = 180;
const defaultExapmleImageHeight = 440;

const radiusMedium = getThemeByPath('radius.medium');

const spacingMedium = getThemeByPath('spacings.medium');

export const FeedbackWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ExampleImageWrapper = styled.div``;

export const ExampleImage = styled(ImageBck)`
  height: ${defaultExapmleImageHeight}px;
  border-radius: ${radiusMedium}px;
`;

export const ReviewWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: ${spacingMedium}px;
`;

export const PersonImageWrapper = styled.div`
  height: ${defaultPersonImageHeight}px;
  width: ${defaultPersonImageHeight}px;
  margin-right: ${spacingMedium}px;
`;

export const PersonImage = styled(Image)`
  border-radius: ${defaultPersonImageHeight / 2}px;
`;
